module.exports = __webpack_public_path__ + "static/img/home.5fae8ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home.png
// module id = 9
// module chunks = 0